import React from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
import { Star } from 'lucide-react';
export function TestimonialsSection() {
  const {
    ref,
    isVisible
  } = useScrollAnimation();
  const testimonials = [{
    quote: 'Pasé de pasarme el domingo entero planificando a terminar todo en una hora. No puedo creer que no lo haya descubierto antes.',
    name: 'María Laura G.',
    role: 'Docente de Primaria, Córdoba',
    avatar: 'https://images.unsplash.com/photo-1544717305-2782549b5136?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80'
  }, {
    quote: 'Compré muchos packs de PDFs antes de esto y ninguno me sirvió. Este sistema es completamente diferente porque aprendés a hacerlo vos misma.',
    name: 'Claudia R.',
    role: 'Profesora de Secundaria, Buenos Aires',
    avatar: 'https://images.unsplash.com/photo-1580894732444-8ecded7900cd?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80'
  }, {
    quote: 'Al principio dudé porque no soy muy tecnológica. Pero el manual está tan bien explicado que lo usé desde el primer día sin problemas.',
    name: 'Patricia M.',
    role: 'Docente de Inicial, Rosario',
    avatar: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80'
  }];
  return <section className="w-full bg-[#F0F4FF] py-24 px-4 sm:px-6 lg:px-8 overflow-hidden" data-id="element-238">
      <div ref={ref} className={`max-w-7xl mx-auto transition-all duration-1000 transform ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} data-id="element-239">
        <div className="text-center mb-16" data-id="element-240">
          <span className="inline-block font-montserrat font-bold text-gold text-sm tracking-widest uppercase mb-4" data-id="element-241">
            LO QUE DICEN LAS DOCENTES
          </span>
        </div>

        <div className="flex overflow-x-auto pb-8 -mx-4 px-4 sm:mx-0 sm:px-0 sm:grid sm:grid-cols-3 gap-6 snap-x snap-mandatory hide-scrollbar" data-id="element-242">
          {testimonials.map((t, idx) => <div key={idx} className="min-w-[300px] sm:min-w-0 bg-white rounded-xl p-8 shadow-sm border-l-[3px] border-gold snap-center flex flex-col" data-id="element-243">
              <div className="flex gap-1 mb-6" data-id="element-244">
                {[...Array(5)].map((_, i) => <Star key={i} size={18} className="fill-gold text-gold" data-id="element-245" />)}
              </div>

              <div className="relative flex-1 mb-8" data-id="element-246">
                <span className="absolute -top-4 -left-2 text-6xl text-gold/20 font-playfair leading-none" data-id="element-247">
                  "
                </span>
                <p className="font-inter text-gray-700 text-[15px] leading-relaxed relative z-10" data-id="element-248">
                  {t.quote}
                </p>
              </div>

              <div className="flex items-center gap-4 mt-auto" data-id="element-249">
                <img src={t.avatar} alt={t.name} className="w-12 h-12 rounded-full object-cover border border-gray-100" data-id="element-250" />
                <div data-id="element-251">
                  <h4 className="font-inter font-bold text-navy text-sm" data-id="element-252">
                    {t.name}
                  </h4>
                  <p className="font-inter text-gray-500 text-xs" data-id="element-253">{t.role}</p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}